import React from 'react';
import PropTypes from 'prop-types';

import { NoLiveEventSC } from './style';
import Text from '../Text';
import Icon from '../Icon';
import theme from '../../theme';

const NoLiveEvent = ({ text }) => (
  <NoLiveEventSC>
    <Icon
      type="graduation-hat-01"
      size={48}
      fill="none"
      stroke={theme().colors.darkerBlue}
      strokeWidth={1.5}
    />
    <Text type="b2">
      {text ||
        'Non ci sono eventi dal vivo al momento. Verranno visualizzati gli eventi da gestire durante la loro durata.'}
    </Text>
  </NoLiveEventSC>
);

NoLiveEvent.propTypes = {
  text: PropTypes.string,
};

export default NoLiveEvent;
